import { Linkedin, ArrowDown, ArrowUpRight } from "lucide-react";
import { MaskedLines, Reveal } from "../Reveal";

const scrollTo = (hash) => (e) => {
  e.preventDefault();
  document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

const CTAS = [
  { label: "Voir mon parcours", hash: "#parcours" },
  { label: "Découvrir mes expertises", hash: "#expertises" },
  { label: "Mes outils & applications", hash: "#outils" },
  { label: "Mes publications", hash: "#publications" },
];

export default function ProfileHero({ profile, photoUrl }) {
  return (
    <section className="relative bg-ink-950 text-paper grain overflow-hidden pt-32 md:pt-44 pb-24 md:pb-32" data-testid="profile-hero">
      <div className="absolute -left-32 top-10 w-[420px] h-[420px] rounded-full bg-gold/10 blur-[130px]" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7">
          <Reveal><span className="label-mono text-gold">[ NovaLean Consulting — Fondateur ]</span></Reveal>
          <MaskedLines lines={[profile.name]}
            className="font-display text-5xl md:text-7xl font-semibold tracking-tight leading-[0.95] mt-6" />
          <Reveal delay={0.15}>
            <p className="font-display text-xl md:text-3xl font-medium text-gold-grad mt-5 max-w-2xl" data-testid="profile-job-title">{profile.job_title}</p>
          </Reveal>
          <Reveal delay={0.22}>
            <div className="flex flex-wrap gap-2 mt-7">
              {profile.tagline.split("•").map((t) => (
                <span key={t} className="label-mono px-3 py-1.5 rounded-full border border-paper/20 text-paper/70">{t.trim()}</span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="flex flex-wrap gap-3 mt-10">
              {CTAS.map((c, i) => (
                <a key={c.hash} href={c.hash} onClick={scrollTo(c.hash)} data-testid={`hero-cta-${i}`}
                  className={i === 0
                    ? "inline-flex items-center gap-2 rounded-full bg-gold text-ink px-6 py-3.5 label-mono hover:bg-paper transition-colors duration-300"
                    : "inline-flex items-center gap-2 rounded-full border border-paper/25 px-6 py-3.5 label-mono text-paper/85 hover:border-gold hover:text-gold transition-colors duration-300"}>
                  {c.label} {i === 0 ? <ArrowDown size={15} /> : <ArrowUpRight size={15} />}
                </a>
              ))}
              {profile.linkedin_url && (
                <a href={profile.linkedin_url} target="_blank" rel="noopener noreferrer" data-testid="hero-cta-linkedin"
                  className="inline-flex items-center gap-2 rounded-full border border-paper/25 px-6 py-3.5 label-mono text-paper/85 hover:border-gold hover:text-gold transition-colors duration-300">
                  <Linkedin size={15} /> LinkedIn
                </a>
              )}
            </div>
          </Reveal>
        </div>
        <Reveal className="lg:col-span-5" delay={0.2}>
          <div className="relative max-w-[380px] mx-auto lg:ml-auto">
            <div className="absolute inset-0 translate-x-4 translate-y-4 rounded-sm bg-gold/25" />
            <img src={photoUrl} alt="Majdi Zarougui — Expert Industrialisation, Lean Manufacturing & Excellence Opérationnelle"
              onError={(e) => { if (!e.currentTarget.dataset.fb) { e.currentTarget.dataset.fb = "1"; e.currentTarget.src = "/images/majdi-zarougui.jpg"; } }}
              className="relative w-full aspect-[4/5] object-cover object-top rounded-sm border border-paper/15 shadow-2xl shadow-ink-950/60" data-testid="profile-photo" />
            {profile.years_experience && (
              <div className="absolute -bottom-6 -left-4 md:-left-6 bg-gold text-ink rounded-sm px-5 py-4 shadow-xl" data-testid="profile-years-badge">
                <div className="font-display text-3xl font-semibold leading-none">{profile.years_experience}</div>
                <div className="label-mono mt-1.5">ans d'expérience terrain</div>
              </div>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
